import { render, staticRenderFns } from "./partner_grid_block.vue?vue&type=template&id=38ecabc4&lang=pug"
import script from "./partner_grid_block.vue?vue&type=script&lang=js"
export * from "./partner_grid_block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports